import Link from 'next/link'
import Trans from 'components/atomic/Trans'
import AutoreCard from 'components/card/AutoreCard'
import SlickSlider from 'react-slick'

const settings = {
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  autoplay: false,
  arrows: false,
  centerPadding: '15px',
}

function BoxAutori({ autori = [], href = '/' }) {
  const listaAutori = autori.map((a) => <AutoreCard autore={a} key={a.id} />)

  return (
    <div className="box-autori">
      <div className="box-autori__head">
        <p className="box-autori__head__title">
          <Trans chiave="Gli autori più importanti" />
        </p>
        <p className="box-autori__head__description">
          <Trans chiave="Spunti di riflessione, webinar e tanto materiale didattico per approfondire i temi caldi del nostro settore." />
        </p>
        <Link legacyBehavior href={href}>
          <a className="box-autori__head__cta button button--primary">Vedi tutti gli autori</a>
        </Link>
      </div>
      <div className="box-autori__content">
        <div className="box-autori__content__list box-autori__content__list--desktop">
          {listaAutori}
        </div>
        <div className="box-autori__content__list box-autori__content__list--mobile">
          <SlickSlider {...settings}>{listaAutori}</SlickSlider>
        </div>
      </div>
    </div>
  )
}

export default BoxAutori
